import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { CurrencyView } from "./CurrencyView";
import { CurrencyViewStore } from "../../store/CurrencyViewStore";
import { useStore } from "../../../../hooks";

export const CurrencyViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/currency/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new CurrencyViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <CurrencyView currencyViewStore={store} />
      </PageLayout>
    </div>
  );
});
